declare var require: any;
import _ = require("underscore");
import $ = require("jquery");
// import * as moment from "moment-timezone";
const moment: any = require("moment-timezone");

export class GlobalLibsRegister {
    static register() {
        GlobalLibsRegister.addGlobalReferences();
        GlobalLibsRegister.configureGlobalLibraries();
    }

    static addGlobalReferences() {
        window["_"] = _;
        window["$"] = $;
        window["moment"] = moment;
    }

    static configureGlobalLibraries() {
        // Todo: Later in the project, do we rly need all tz data?
        moment.tz.load(require("../../node_modules/moment-timezone/data/packed/latest.json"));
    }
}



// WEBPACK FOOTER //
// ./src/app/GlobalLibsRegister.ts